import React, { createContext, useState, useContext, useEffect } from "react";
import PeopleDealingIssues from "../components/Issues/PeopleDealingIssues";
import Community from "../components/Community/Community";
import { fetchIssuesData, getIssueInsight } from "../services/apis";
import EmotionalVenting from "../components/Issues/EmotionalVenting";
import PeopleDealingLifeChallenges from "../components/Issues/LifeChallenges";
import PeopleDealingMentalHealth from "../components/Issues/MentalHealth";
import PeopleDealingPersonalGrowth from "../components/Issues/PersonalDevelopment";
import { useAuth } from "./authContext";

const RenderContext = createContext();

export const useRender = () => useContext(RenderContext);

export const RenderProvider = ({ children }) => {
  const [selectedOption, setSelectedOption] = useState("Overall");
  const [issuesData, setIssuesData] = useState(null);
  const [issuesInsight, setIssuesInsights] = useState(null);
  // console.log(issuesData)

  const { code } = useAuth();

  useEffect(() => {
    // if (!issuesData) {
    const fetchData = async () => {
      try {
        const data = await fetchIssuesData(code);
        // console.log(data)
        setIssuesData(data);
      } catch (error) {
        console.error("Error fetching issues data:", error);
      }
    };
    fetchData();
    // }
  }, [code]);

  useEffect(() => {
    if (!issuesData) {
      const fetchData = async () => {
        try {
          const insight = await getIssueInsight(code);
          // console.log(insight)
          setIssuesInsights(insight);
        } catch (error) {
          console.error("Error fetching issues data:", error);
        }
      };
      fetchData();
    }
  }, [issuesData, code]);

  const options = [
    "Overall",
    "Mental Health Issues",
    "Emotional Venting",
    "Life Challenges",
    "Personal Growth",
  ];

  const renderComponent = () => {
    switch (selectedOption) {
      case "Overall":
        return <PeopleDealingIssues />;
      case "Mental Health Issues":
        return <PeopleDealingMentalHealth />;
      // case 'community':
      //   return <Community />;
      case "Emotional Venting":
        return <EmotionalVenting />;
      case "Life Challenges":
        return <PeopleDealingLifeChallenges />;
      case "Personal Growth":
        return <PeopleDealingPersonalGrowth />;
      default:
        return null;
    }
  };

  const renderText = () => {
    if (issuesInsight)
      if (issuesInsight)
        // console.log(issuesInsight?.status,"---hum--");
        switch (selectedOption) {
          case "Overall":
            return issuesInsight?.Overall;
          case "Mental Health Issues":
            return issuesInsight["Mental Health Issues"];
          // case 'community':
          //   return <Community />;
          case "Emotional Venting":
            return issuesInsight["Emotional Venting"];
          case "Life Challenges":
            return issuesInsight["Life Challenges"];
          case "Personal Growth":
            return issuesInsight["Personal Growth"];
          default:
            return null;
        }
  };

  return (
    <RenderContext.Provider
      value={{
        selectedOption,
        setSelectedOption,
        options,
        issuesInsight,
        renderComponent,
        issuesData,
        setIssuesData,
        renderText,
      }}
    >
      {children}
    </RenderContext.Provider>
  );
};
